import React from 'react'
import Layout from "../../../components/layout/Layout";
import {useHistory} from "react-router-dom"
import Commonrightcircle from "../../../common/component/RightCircle/commonrightcircle";
import {withRouter} from "../../../common/hocs/routing-hoc";

function EmailSent(props) {
    const history = useHistory();
    return (
        <React.Fragment>
            <Layout module="emailsent">
                <Commonrightcircle/>
                <div className="u_sendmail-section u_t-center u_mt-50">
                    <span className="u_sendmail-icon u_ib u_relative">
                        <img src="../images/images/email-sent.svg" alt="Round"/>
                    </span>
                    <h2 className="u_pt-12">We’ve sent you an email.</h2>
                    <p className="u_pt-12 u_pb-30">We’ve sent an email with a link to reset password. If you don’t
                        receive it soon, Please check your spam folder or go back to the previous page and try entering
                        your email
                        again.</p>
                    <button className="u_account-btn u_w-full u_cp" onClick={() => history.push(props?.projectRoutes?.login || "/login")}>Login
                    </button>
                </div>
            </Layout>
        </React.Fragment>
    )
}


export default withRouter(EmailSent)

